module.exports = __webpack_public_path__ + "img/popup14.93638a87.png";